import * as actions from "./actions";

export default function cabinsReducer(state = [], action) {
    switch (action.type) {

    case actions.GET_CABINS_SUCCESS:
    case actions.GET_CABINS_FAIL:
    {
        return action.payload;
    }
    default:
        return state;

    }
}
